<div  class="leftmenuBlock">

<div class="leftLogo"><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/broko_v1_logo.png" alt="#"></div>
<div class="leftLogosmall"><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/Broko_MobileLogo.png" alt="#"></div>

<div class="menuBlock">
   <ul> 
        <li><a mat-list-item [ngClass]="activemenu=='dashboard'?'active':''" (click)="dashboardPage()"><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/adminpage/icon1.webp"> <label>Dashboard</label></a></li>
        <li><a mat-list-item [ngClass]="activemenu=='user-list'?'active':''" (click)="userListPage()"><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/adminpage/icon2.webp">  <label>User Management
        </label></a></li>
 
        <li><a mat-list-item><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/adminpage/icon5.webp">  <label>Lead Management
        </label></a></li>
        <li><a mat-list-item><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/adminpage/icon6.webp">  <label>Property Listings</label></a></li>
        <li><a  mat-list-item><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/adminpage/icon3.webp">  <label>Communications</label></a></li>
        <li><a  mat-list-item><img src="https://all-frontend-assets.s3.amazonaws.com/broko-design/adminpage/icon4.webp">  <label>Activity Tracker</label></a></li>
    </ul>
</div>
</div>

